import { TiWarningOutline } from "react-icons/ti";
import { FaArrowDown, FaArrowUp } from "react-icons/fa"; 
import { FcHighPriority } from "react-icons/fc";
import { FcMediumPriority } from "react-icons/fc";
import { FcLowPriority } from "react-icons/fc";
export const periotyQueryEnum = [
  // { 
  //   label: "Low Query", 
  //   value: "Low Query", 
  //   icon: <FcLowPriority className="text-yellow-500 text-lg" /> 
  // },
  { 
    label: "Minor Query", 
    value: "MINOR", 
    icon: <TiWarningOutline className="text-yellow-500 text-lg" /> 
  },
  { 
    label: "Major Query", 
    value: "MAJOR", 
    icon: <FcHighPriority className="text-red-500 text-lg" /> 
  },
];

export const getPriorityBadgeColor = (priority) => {
    switch (priority?.toUpperCase()) {
      case "HIGH":
      case "MAJOR":
        return "bg-red-50 text-red-600 border border-red-200";
      case "MEDIUM":
      case "MINOR":
        return "bg-orange-50 text-orange-600 border border-orange-200";
      case "LOW":
        return "bg-yellow-50 text-yellow-600 border border-yellow-200";
      default:
        return "bg-gray-50 text-gray-600 border border-gray-200";
    }
  };

export const queryCategories = [
  { value: "General", label: "General" },
  { value: "Advocate Analysis", label: "Advocate Analysis" },
  { value: "VAO Analysis", label: "VAO Analysis" },
  // { value: "Register Office Analysis", label: "Register Office Analysis" },
  { value: "Physical Inspection", label: "Physical Inspection" },
  // { value: "Other Analysis", label: "Other Analysis" },
];
